import { useEffect, useState } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { Button } from 'react-bootstrap';

export interface IFormModelSheetSignatureInputProps {
  onChange: (signatureImage: string) => void;
  onSign: () => void;
  scaleHeight?: number;
}

const FormModelSheetSignatureInput = ({
  onChange,
  onSign,
  scaleHeight,
}: IFormModelSheetSignatureInputProps) => {
  const [signatureData, setSignatureData] = useState<string>();
  const [isSignEnabled, setIsSignEnabled] = useState<boolean>(false);

  let sigRef: SignatureCanvas;

  useEffect(() => {
    if (signatureData) {
      onChange(signatureData.substring(signatureData.lastIndexOf(',') + 1));
      setIsSignEnabled(true);
    } else {
      setIsSignEnabled(false);
    }
  }, [signatureData]);

  const doClearSignaturePad = () => {
    sigRef.getSignaturePad().clear();
    setSignatureData(undefined);
  };

  const doScaleCanvas = (canvas: HTMLCanvasElement): HTMLCanvasElement => {
    let copy = document.createElement('canvas');
    copy.width = canvas.width;
    copy.height = scaleHeight || canvas.height;
    const ctx = copy.getContext('2d');
    if (ctx) {
      ctx.drawImage(
        canvas,
        0,
        0,
        canvas.width,
        canvas.height,
        0,
        0,
        copy.width,
        scaleHeight || copy.height,
      );
    } else {
      throw new Error('Failed to get canvas for trimmed clone');
    }

    return copy;
  };

  return (
    <>
      <div>
        <SignatureCanvas
          penColor='black'
          clearOnResize={false}
          dotSize={2}
          minWidth={0.5}
          maxWidth={1.5}
          canvasProps={{
            width: 300,
            height: 75,
            className: 'sigCanvas',
          }}
          onEnd={() => setSignatureData(doScaleCanvas(sigRef.getTrimmedCanvas()).toDataURL())}
          ref={(ref) => {
            if (ref) sigRef = ref;
          }}
        />
      </div>
      <div className='ms-3'>
        <Button disabled={!isSignEnabled} onClick={onSign}>
          Save Contract
        </Button>
        <Button className='ms-2' onClick={doClearSignaturePad}>
          Clear
        </Button>
      </div>
    </>
  );
};

export default FormModelSheetSignatureInput;
